<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
<!-- Breadcrumb y ayuda -->    
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container" v-if="p_Opcion==1">
            <router-link to="/atencion">Atenciones</router-link> >
            <router-link :to="'/atencionform/' + datoInterconsulta.idAtencion">Atención {{ p_NumeroAtencion }}</router-link> >
            <router-link :to="'/atencion_interconsulta/' + datoInterconsulta.idAtencion + '/' + p_NumeroAtencion">Interconsultas</router-link> 
            > {{ datoInterconsulta.especialidad }}
          </div>
          <div class="breadcrumb-container" v-if="p_Opcion==2">
            <router-link to="/medico_interconsulta/4">Interconsultas</router-link> > 
            {{ datoInterconsulta.especialidad }}
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>
    <hr>
<!-- Modal -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInterconsulta.idInterconsulta" disabled>
                </div>
              </div>
            </div>
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoInterconsulta.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="paciente" class="form-label">Paciente</label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control" id="paciente" name="paciente" v-model="datoInterconsulta.paciente" disabled>                    
                </div>
<!--                 <div class="col-1">
                  <label for="medico" class="form-label">Médico</label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control" id="medico" name="medico" v-model="datoInterconsulta.medico" disabled>                    
                </div> -->
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="especialidad" class="form-label">Especialidad</label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control" id="especialidad" name="especialidad" v-model="datoInterconsulta.especialidad" disabled>                    
                </div>
                <div class="col-1">
                  <label for="medico" class="form-label">Médico</label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control" id="medico" name="medico" v-model="datoInterconsulta.medico" disabled>                    
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-11">
                  <textarea class="form-control" id="motivo" name="motivo" v-model="datoInterconsulta.motivo" disabled></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-11">
                <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInterconsulta.cuadro" disabled></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
<!--
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarInterconsulta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInterconsulta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
-->
    </div>
  </div>

    <div v-if="p_Opcion==2">
      <router-link :to="'/informeinter_diaginter/'+ datoInterconsulta.idAtencion + '/' + datoInterconsulta.idInterconsulta" class="btn btn-light" title="Informe">
        <i class="material-icons" style="font-size:32px;color:greenyellow; cursor: pointer;">summarize</i>
        Generar Informe
      </router-link>

      <router-link :to="'/informeinter_diaginter/'+ datoInterconsulta.idAtencion + '/' + datoInterconsulta.idInterconsulta" class="btn btn-light" title="Informe">
        <i class="material-icons" style="font-size:32px;color:green; cursor: pointer;">summarize</i>
        Editar Informe
      </router-link>
    </div>

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
//import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      interconsultas : [],
      datoInterconsulta : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      p_idInterconsulta: 0,
      p_Opcion: 0,
      showTable: 'biomAten', // Pestaña por defecto
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.p_Opcion = this.$route.params.p_opcion
    this.p_NumeroAtencion = this.$route.params.p_numero_atencion
    this.p_idInterconsulta = this.$route.params.p_idinterconsulta
    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
   getData() {
      api.get('/vwinterconsultas/'+this.p_idInterconsulta)
        .then(response => {
          this.datoInterconsulta = response.data;
        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    },
/*    
    async guardarInterconsulta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/interconsultas', this.datoInterconsulta)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Interconsulta creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
*/    
  },
}
</script>
<style src="@/assets/css/tabs.css" scoped></style>